import { logger } from '@luna/logger';

import type { TokenRefresh } from './types';

class TokenRefreshQueue {
    private pendingTokenRefresh: Promise<void> | undefined;

    refreshToken(refresh: TokenRefresh): Promise<void> {
        if (!this.pendingTokenRefresh) {
            this.pendingTokenRefresh = refresh()
                .then(() => {
                    this.pendingTokenRefresh = undefined;
                })
                .catch((e) => {
                    this.pendingTokenRefresh = undefined;
                    throw e;
                });
        }

        return this.pendingTokenRefresh;
    }

    waitForTokenRefresh(): Promise<void> {
        if (this.pendingTokenRefresh) {
            return this.pendingTokenRefresh.catch((e) => {
                logger.error('Refreshing token failed', e);
            });
        }
        return Promise.resolve();
    }
}

export const tokenRefreshQueue = new TokenRefreshQueue();
